import type { FC } from 'react';

import { connect } from 'react-redux';

import { getFacility } from 'src/app/state/selectors';
import type { RootState } from 'src/app/state/store';

const FaxNumberRenderer: FC = ({ facility, className }) => {
  return (
    <a className={className} href={`tel:${facility?.fax}`}>
      {facility?.fax}
    </a>
  );
};

const mapStateToProps = (state: RootState) => {
  const facility = getFacility(state);
  return { facility };
};

export const FaxNumber = connect(mapStateToProps, null)(FaxNumberRenderer);
